import { FormBuilder } from '@angular/forms';
import { RelatorioService } from "./../services/relatorio/relatorio.service";
import { SnotifyService } from 'ng-snotify';
import { FormControl, FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-relatorio-arquivos-pendentes',
  templateUrl: './relatorio-arquivos-pendentes.component.html',
  styleUrls: ['./relatorio-arquivos-pendentes.component.scss']
})
export class RelatorioArquivosPendentesComponent implements OnInit {

  public loading = true;

  public listaArquivos:Array<any> = [];

  public lastResponse: any = null

  public perPage:number = 10

  public currentPage:number = 1

  public filter: FormGroup = this.fb.group({
    data_inicio: new FormControl('', []),
    data_fim: new FormControl('', []),
  });

  constructor(
      private _notify: SnotifyService,
      private relatorioService: RelatorioService,
      private fb: FormBuilder
  )  { 
  }

  ngOnInit() { 
    this.loadData();
  }

  public loadData() {
    this.loading = true;
    this.relatorioService.qtdArquivosPendentePorData(this.getFilters(), this.currentPage, this.perPage).subscribe(
        ({data}:any) => {
            this.loading = false
            this.lastResponse = data;
            this.listaArquivos = this.listaArquivos.concat(this.lastResponse.arquivos.data)
        },
        error => {
            this.loading = false
            this._notify.error("Ocorreu um erro ao carregar os dados")
        }
    )
  }

  public loadPerPage($event) {
      this.perPage = $event.target.value
      this.reset(false)
      this.loadData()
  }

  public reset(reload: boolean): void {
      this.listaArquivos = []
      this.currentPage = 1

      if(reload) {
        Object.keys(this.filter.controls).forEach(key => {
          this.filter.controls[key].setValue(null);
        });

        this.loadData();      
      }
  }

  public loadMore():void {
      this.currentPage++;
      this.loadData()
  }

  public toFilter() {
    this.reset(false);
    this.loadData();
  }

  public getFilters() {
    const filter = {};

    Object.keys(this.filter.controls).forEach((_filter) => {
      filter[_filter] = this.filter.controls[_filter].value;
    });

    return filter;
  }
}